<template>
  <div class="blog-post-list">
    <h1 class="title centered">Blog</h1>
    <div class="posts">
      <BlogListItem
        v-for="post in blogPosts"
        v-bind:key="post.data.slug"
        :id="post.data.slug"
        :date="new Date(post.data.date)"
        :title="post.data.title"
        :excerpt="post.data.excerpt || getExcerpt(post.content)" />
    </div>
  </div>
</template>

<style lang="stylus">

</style>

<script>
import * as _ from 'lodash'
import { mapState, mapActions } from 'vuex'
import BlogListItem from '../components/BlogListItem'

export default {
  computed: {
    ...mapState(['blogPosts']),
    sortedPosts () {
      return _.sortBy(this.blogPosts, [(o) => {
        return o.data.date || o.data.slug
      }]).reverse()
    }
  },
  methods: {
    ...mapActions(['loadBlogPosts']),
    getExcerpt (content) {
      return content.substring(0, content.indexOf('\n'))
    }
  },
  mounted () {
    return this.loadBlogPosts()
  },
  components: {
    BlogListItem
  }
}
</script>
